.list {
  position: relative;
  overflow: hidden;
}

.loader-hidden {
  visibility: hidden;
}

#endpoint-loader {
  position: absolute;
  width: 100%;
  height: calc(100% - var(--search-input-height));
  background-color: var(--white-layout-300-primary);
  z-index: 100;
  left: 0;

  & > .spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
}
